import type { ReactNode } from 'react'

import { LAYOUT_IDS } from '../dom-ids'

type AppPageProps = {
  children: ReactNode
}

export function AppPage({ children }: AppPageProps) {
  return (
    <div className="app-page flex min-h-0 flex-1 flex-col overflow-hidden">
      <main
        id={LAYOUT_IDS.main}
        className="layout-main flex min-h-0 flex-1 flex-col w-full"
      >
        {children}
      </main>
    </div>
  )
}
